class FileValidationError extends Error {}

export class FileNameExceedsMaxLengthError extends FileValidationError {
  constructor() {
    super();
    this.message = 'File name too long';
    this.code = 'FILE_NAME_TOO_LONG';
  }
}
